import { RecaptchaRunner } from './recaptcha'
import _ from 'lodash'

let _runner = null

export function getRecaptchaRunner (config) {
  if (_runner === null) {
    _runner = new RecaptchaRunner(config)
  }
  return _runner
}

export function apiResponseTransformer (resp) {
  if (!resp.data) {
    resp.data = {}
  }
  // precondition failed
  if (resp.status === 412) {
    // try to get ip address
    // sample response:
    // {"error":{"code":150013,"title":"Precondition Failed","message":"request failed captcha: 1.1.1.1"}}
    const message = _.get(resp, 'data.error.message', ':')
    resp.data.ip = message.split(':')[1].trim()
    resp.data.isRecaptchaOk = false
  } else {
    resp.data.isRecaptchaOk = true
  }
}
